import React, { useState, useEffect } from "react";
import styled from "styled-components";
import closeIcon from "../../../assets/imgs/close-new.svg";
import Axios from "axios";
import {wrapperEndPoint} from "../../Utils/Api"

const OverlayIFSCInput = (props) => {
  let selectedIFSCCode = "IFSC00000";
  const [branchName, setBranchName] = useState("");
  const [cityName, setCityName] = useState("");
  const [IfscOptions, setIfscOptions] = useState([]);

  const handleCancel = () => {
    props.overlayIFSCInputToggle();
  };

  const handleSubmit = () => {
    let bankDetails = {
      bankName: props.userSelectedBankName,
      bankBranch: branchName,
      cityName: cityName,
    };
   
    Axios.post(wrapperEndPoint.genericRouterURL, {
      wrapperEndPoint: "/RBLWrapper/rbl/creditCard/CcStplFindIfsc",
      findIFSC: JSON.stringify(bankDetails),
    },{headers: {
      "Content-Type": "application/json"}
  })
      .then((response) => response.data)
      .then((response) => {
        let items = response.response.responseJson;
        if (items == "invalid ifsc") {
          // props.selectedIFSCCode("", "");
          props.toggleOverlayMessage("IFSC not found.");
        } else {
          setIfscOptions(items);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    //
  };

  const handleBranchName = (e) => {
    if (e.target.id == "bank-city") {
      setCityName(e.target.value);
    } else if (e.target.id == "bank-branch") {
      setBranchName(e.target.value);
    }
  };

  return (
    <OverlayBlock>
      <MainBlock>
        {/* <Message>
               {props.message}
            </Message> */}
        <CloseBlock onClick={() => handleCancel()}>
          <img src={closeIcon} />
        </CloseBlock>
        {IfscOptions.length == 0 ? (
          <div>
            <IFSCInputBlock>
              <div className="input-block">
                <label className="title-label" style={{ fontWeight: "500" }}>
                  {props.userSelectedBankName}
                </label>
                <br />
                {/* <input className= "user-input"  placeholder={props.userSelectedBankName} disabled={true}></input> */}
              </div>
              <div className="input-block">
                <label className="title-label">Branch Name</label>
                <br />
                <input
                  id="bank-branch"
                  className="user-input"
                  placeholder="Enter the Branch Name"
                  onChange={() => handleBranchName(event)}
                />
              </div>
              <div className="input-block">
                <label className="title-label">City</label>
                <br />
                <input
                  id="bank-city"
                  className="user-input"
                  placeholder="Enter the City"
                  onChange={() => handleBranchName(event)}
                />
              </div>
            </IFSCInputBlock>
            {/* <ActionButton onClick={() => handleSubmit()}>
          Find IFSC Code
        </ActionButton> */} 
            <div className="action-elem"
              onClick={
                branchName == "" || cityName == ""
                  ? () =>
                      props.toggleOverlayMessage("Enter Branch and City Names")
                  : () => {
                      handleSubmit();
                    }
              }
            >
              Submit
            </div>
          </div>
        ) : (
          <div>
            <b>IFSC List</b>
            <div className="IFSCList">
              {IfscOptions.map((e, i) => {
                return (
                  <div
                    className="IfscOptions"
                    key={i}
                    onClick={() => {
                      props.selectedIFSCCode(e.ifsc, e.address);
                    }}
                  >
                    Branch Name: {e.branchName} <br />
                    IFSC Code: <b style={{ color: "#4bb6dd" }}>{e.ifsc}</b>
                    {/* <br /> */}
                    {/* Address: {e.address} */}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </MainBlock>
    </OverlayBlock>
  );
};

const OverlayBlock = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.2);
  z-index: 100;
`;
const MainBlock = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  width: 80%;
  height: max-content
  transform: translate(-50%, -50%);
  padding: 32px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;
`;
const CloseBlock = styled.div`
  float: right;
  position: relative;
  top: -10px;
  right: -10px;
  cursor: pointer;
`;
const IFSCInputBlock = styled.div`
  height: auto;
  margin-top: 15px;
  & .input-block {
    margin-bottom: 16px;
  }
  & .title-label {
    padding-left: 4px;
    color: #000;
  }
  & .user-input {
    background-color: #fff;
    border: 1px solid #999999;
    //box-shadow: 0px 5px 12px rgba(0,0,0,0.2);
    border-radius: 2px;
    height: 44px;
    width: 100%;
    color: #ccc;
    padding-left: 15px;
    font-size: 14px;
    color: #666666;
    margin-top: 4px;
  }
`;
// const Message=styled.div`
//   text-align:center;
//   padding-bottom:12px;
// `
const ActionButton = styled.div`
  width: 100%;
  // max-width: 200px;
  margin: 10px auto;
  background: #003e8d;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
`;

export default OverlayIFSCInput;
